import { FC, HTMLAttributes, memo } from 'react';
import cn from 'classnames';

import Button from '@UI/Button';
import { WikiTagData } from '@Types/Wiki';
import styles from './WikiPopularTags.module.css';

export interface WikiPopularTagsProp extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  tags: WikiTagData[];
}

const WikiPopularTags: FC<WikiPopularTagsProp> = (props) => {
  const { className, tags, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.wikiPopularTags, className)}>
      <div className={styles.title}>Популярные теги</div>

      <div className={styles.tagsWrapper}>
        {tags.map((tag, index) => (
          <Button
            theme='transparent'
            view='rounded'
            to={tag.link}
            className={styles.tagItem}
            key={index}
          >
            {tag.title}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default memo(WikiPopularTags);
